module.exports = __webpack_public_path__ + "img/Weapon_127.7539be27.png";